export default async function presentation (state, appOptions, lastPage) {
  const RemoteControl = (await import(/* webpackChunkName: 'remote' */ '../../components/remote')).default

  // short circuit if the page has changed during async loading
  if (state.get('page') !== 'remote') {
    return
  }

  const view = new RemoteControl({
    model: state.get('user'),
    debug: appOptions.debug
  })

  view.on('done', () => state.changePage(lastPage))
  return view
}
